'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterAndSort = exports.canMeetDeliveryTime = exports.isAvailable = exports.doesDeliverToLatLng = exports.canMeetPrice = exports.isActive = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _pointInPolygon = require('point-in-polygon');

var _pointInPolygon2 = _interopRequireDefault(_pointInPolygon);

var _availability = require('availability');

var availability = _interopRequireWildcard(_availability);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isActive = exports.isActive = function isActive(_ref) {
    var info = _ref.info;
    return !info.inactive;
};

var canMeetPrice = exports.canMeetPrice = function canMeetPrice(_ref2) {
    var info = _ref2.info,
        orderPrice = _ref2.orderPrice;
    return (info.minOrderPrice || 0) <= orderPrice;
};

var doesDeliverToLatLng = exports.doesDeliverToLatLng = function doesDeliverToLatLng(_ref3) {
    var info = _ref3.info,
        latLng = _ref3.latLng;
    return (0, _pointInPolygon2.default)(normalizeLatLng(latLng), _lodash2.default.map(info.area, normalizeLatLng));
};

var isAvailable = exports.isAvailable = function isAvailable(_ref4) {
    var info = _ref4.info,
        orderTime = _ref4.orderTime;

    var iter = new availability.AvailabilityIterator({ cal: orderTime.clone(), availability: info.availability || {} });
    return iter.hasNext() && iter.next().status === 'available';
};

var canMeetDeliveryTime = exports.canMeetDeliveryTime = function canMeetDeliveryTime(_ref5) {
    var info = _ref5.info,
        orderTime = _ref5.orderTime,
        now = _ref5.now;

    var timeDiff = parseInt((orderTime.valueOf() - now.valueOf()) / 1000 / 60);
    return timeDiff >= 0 && info.delayMins <= timeDiff;
};

var filterAndSort = exports.filterAndSort = function filterAndSort(_ref6) {
    var infos = _ref6.infos,
        _ref6$filter = _ref6.filter,
        filter = _ref6$filter === undefined ? {} : _ref6$filter,
        sortBy = _ref6.sortBy;
    var orderPrice = filter.orderPrice,
        latLng = filter.latLng,
        orderTime = filter.orderTime,
        now = filter.now;


    infos = _lodash2.default.filter(infos, function (info) {
        return info.type === 'delivery' && isActive({ info: info });
    });

    if (orderPrice || orderPrice === 0) {
        infos = _lodash2.default.filter(infos, function (info) {
            return canMeetPrice({ info: info, orderPrice: orderPrice });
        });
    }

    if (latLng) {
        infos = _lodash2.default.filter(infos, function (info) {
            return doesDeliverToLatLng({ info: info, latLng: latLng });
        });
    }

    if (orderTime) {
        infos = _lodash2.default.filter(infos, function (info) {
            return isAvailable({ info: info, orderTime: orderTime });
        });
    }

    if (now && orderTime) {
        infos = _lodash2.default.filter(infos, function (info) {
            return canMeetDeliveryTime({ info: info, orderTime: orderTime, now: now });
        });
    }

    if (sortBy) {
        infos = _lodash2.default.sortBy(infos, sortBy);
    }

    return infos;
};

var normalizeLatLng = function normalizeLatLng(latLng) {
    return [latLng.lat, latLng.lng];
};